import React from 'react'
import TechRoadmapApp from './tech-roadmap'
import Funders2025App from './funders-2025'
import ProductsApp from './products'
import EnduroFundersApp from './enduro-funders'
import AgilitasFundersApp from './agilitas-funders'
import IscFundersApp from './isc-funders'
import AstonFundersApp from './aston-funders'
import CompanyMergeReviewApp from './company-merge-review'
import AllCompaniesApp from './all-companies'
import CompaniesHouseWatchApp from './companies-house-watch'
import SalesWatchApp from './sales-watch'

/**
 * Registry of native applications that are built into the client portal.
 * Maps application IDs from the database to their React components.
 * 
 * When adding a new native app:
 * 1. Create the app component in src/apps/[app-name]
 * 2. Import it here
 * 3. Add it to the registry with its database ID as the key
 * 4. Insert a record in the applications table with app_type='native'
 */
export const NATIVE_APP_REGISTRY: Record<string, React.ComponentType> = {
  // Tech Roadmap - UUID from database: c5cb37a3-a438-4cf4-9636-e4fe1f2b4b0b
  'c5cb37a3-a438-4cf4-9636-e4fe1f2b4b0b': TechRoadmapApp,
  
  // 2025 Funders - UUID from database: f0b37d04-4309-42eb-a446-09d535f94461
  'f0b37d04-4309-42eb-a446-09d535f94461': Funders2025App,
  
  // Products - UUID from database: de9306e0-f441-49de-844a-ab4c49529deb
  'de9306e0-f441-49de-844a-ab4c49529deb': ProductsApp,
  
  // Enduro Funders - UUID from database: a7e8f3b2-9c4d-4e6a-b8f1-2d3a5c7e9f0b
  'a7e8f3b2-9c4d-4e6a-b8f1-2d3a5c7e9f0b': EnduroFundersApp,
  
  // Agilitas Funders - TODO: replace with actual UUID from database
  'b5a2d7e0-1d7e-4d58-8c2a-7f58afc1a9c7': AgilitasFundersApp,

  // ISC Funders - TODO: replace with actual UUID from database
  'c3f4a8b1-5e9d-4c2a-9f7b-8d3e6a1c5f2d': IscFundersApp,

  // Aston Funders - TODO: replace with actual UUID from database
  'd4e5b9c2-6f0e-4d3b-a8c9-9e4f7b2d6a3e': AstonFundersApp,

  // Company Merge Review - UUID from database: 85ee895d-d7ce-44e7-afc2-b2bd09c7b8bc
  '85ee895d-d7ce-44e7-afc2-b2bd09c7b8bc': CompanyMergeReviewApp,

  // All Companies - UUID from database: a853e2c2-d32c-4ada-ae47-3cd91142d61b
  'a853e2c2-d32c-4ada-ae47-3cd91142d61b': AllCompaniesApp,

  // Companies House Watch - UUID must match the applications row inserted by
  // docs/companies-house-watch.sql
  '6b1f4c8e-95d2-4a7b-8c3e-1f0a9d6e2b47': CompaniesHouseWatchApp,

  // Sales Watch - weekday morning director digest (worker: ceo_digest.py)
  '9f3a6b2c-4d1e-48f7-a5c9-8e2b7d4f1a6c': SalesWatchApp,

  // Add future native apps here
  // 'app-uuid': AppComponent,
}

/**
 * Helper function to check if an application ID corresponds to a native app
 */
export const isNativeApp = (appId: string): boolean => {
  return appId in NATIVE_APP_REGISTRY
}

/**
 * Helper function to get the component for a native app
 */
export const getNativeAppComponent = (appId: string): React.ComponentType | null => {
  return NATIVE_APP_REGISTRY[appId] || null
}
